import React from 'react';
import PropTypes from 'prop-types';
import QdtComponents from 'qdt-components';
import autobind from 'autobind-decorator';

const options = {
  config: {
    host: 'sense-demo.qlik.com',
    secure: true,
    port: 443,
    prefix: '',
    appId: '5a9852ae-b2f3-47c5-8f21-6a6468cea55a',
  },
  connections: {
    vizApi: true,
    engineApi: true,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

export default class QdtComponent extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    props: PropTypes.object,
    handleGetSelected: PropTypes.func,
    handleSetSelected: PropTypes.array,
  }
    static defaultProps = {
      handleGetSelected: null,
      handleSetSelected: null,
      props: null,
    }

    constructor(props) {
      super(props);
      this.state = {
        qObject: null,
      };
    }

    async componentWillMount() {
      const {
        type, props, handleGetSelected, handleSetSelected,
      } = this.props;
      const qDoc = await qdtComponents.qDocPromise;
      qDoc.clearAll();
      if (type === 'SelectionApi') {
        const qProp = { qInfo: { qType: 'SelectionObject' }, qSelectionObjectDef: {} };
        const qObject = await qDoc.createSessionObject(qProp);
        this.setState({ qObject });
        qDoc.on('changed', () => { this.getLayout(); });
        if (handleGetSelected) await this.getLayout();
        if (handleSetSelected && handleSetSelected.length) {
          handleSetSelected.forEach(async (element) => {
            const qField = await qDoc.getField(element.field);
            const qFieldValues = element.values.split(',').map(obj => ({ qText: obj }));
            qField.selectValues(qFieldValues, true, true);
          });
        }
      } else if (type === 'FieldApi') {
        const qProp = props.fields.map(field => ({
          qInfo: { qType: 'visualization' },
          qListObjectDef: {
            qStateName: '$',
            qLibraryId: '',
            qDef: {
              qGrouping: 'N',
              qFieldDefs: [field],
              qFieldLabels: ['Dim1'],
              autoSort: false,
              qSortCriterias: [
                {
                  qSortByNumeric: -1,
                  qSortByLoadOrder: 0,
                },
              ],
            },
            qInitialDataFetch: [
              {
                qTop: 0,
                qLeft: 0,
                qHeight: 100,
                qWidth: 1,
              },
            ],
          },
        }));
        const qObject = qProp.map(prop => qDoc.createSessionObject(prop));
        Promise.all(qObject).then(async (values) => {
          if (
            handleSetSelected && handleSetSelected.field1 !== '' &&
            handleSetSelected.values1 !== '' &&
            handleSetSelected.field2 &&
            handleSetSelected.field2 !== '' &&
            handleSetSelected.values2 &&
            handleSetSelected.values2 !== ''
          ) {
            const urlParams1 = handleSetSelected.values1.split(',');
            const urlParams2 = handleSetSelected.values2.split(',');
            const qLayout1 = await values[0].getLayout();
            const qLayout2 = await values[1].getLayout();
            const qElemNumbers1 = qLayout1.qListObject.qDataPages[0].qMatrix.filter(obj => urlParams1.includes(obj[0].qText)).map(obj => obj[0].qElemNumber);
            const qElemNumbers2 = qLayout2.qListObject.qDataPages[0].qMatrix.filter(obj => urlParams2.includes(obj[0].qText)).map(obj => obj[0].qElemNumber);
            await values[0].selectListObjectValues('/qListObjectDef', qElemNumbers1, false);
            await values[1].selectListObjectValues('/qListObjectDef', qElemNumbers2, false);
          } else if (
            handleSetSelected &&
            handleSetSelected.field1 !== '' &&
            handleSetSelected.values1 === '@latest'
          ) {
            const qLayout = await values[0].getLayout();
            const { qElemNumber } = qLayout.qListObject.qDataPages[0].qMatrix[0][0];
            await values[0].selectListObjectValues('/qListObjectDef', [qElemNumber], false, false);
          } else if (
            handleSetSelected &&
            handleSetSelected.field1 !== '' &&
            handleSetSelected.values1 !== ''
          ) {
            const urlParams = handleSetSelected.values1.split(',');
            const qLayout = await values[0].getLayout();
            const qElemNumbers = qLayout.qListObject.qDataPages[0].qMatrix.filter(obj => urlParams.includes(obj[0].qText)).map(obj => obj[0].qElemNumber);
            await values[0].selectListObjectValues('/qListObjectDef', qElemNumbers, false);
          } else {
            this.setState({ qObject: values });
            qDoc.on('changed', () => { this.getFieldLayout(); });
          }
        });
      }
    }

    componentDidMount() {
      const { type, props } = this.props;
      if (type !== 'SelectionApi' && type !== 'FieldApi') {
        qdtComponents.render(type, props, this.node);
      }
    }

    componentDidUpdate() {
    }

    @autobind
    async getLayout() {
      const { handleGetSelected } = this.props;
      const { qObject } = this.state;
      const qLayout = await qObject.getLayout();
      const { qSelections } = qLayout.qSelectionObject;
      if (qSelections.length && handleGetSelected) handleGetSelected(qSelections);
    }

    @autobind
    async getFieldLayout() {
      const { handleGetSelected, props } = this.props;
      const { qObject } = this.state;
      const qLayout = qObject.map(obj => obj.getLayout());
      Promise.all(qLayout).then((data) => {
        let qSelections = data.map((d, i) => ({
          field: props.fields[i],
          values: d.qListObject.qDataPages[0].qMatrix.filter(obj => obj[0].qState === 'S').map(obj => obj[0].qText).join(),
        }));
        if (qSelections[0].values === '' && (qSelections[1] && qSelections[1].values === '')) qSelections = [];
        if (qSelections.length && handleGetSelected) handleGetSelected(qSelections);
      });
    }


    render() {
      const { props } = this.props;
      return (
        <div ref={(node) => { this.node = node; }} id={(props.id) ? props.id : null} />
      );
    }
}



// WEBPACK FOOTER //
// ./src/components/QdtComponent.jsx